import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type { ReactElement } from 'react'
import type {
  TestResultStepParams,
  TestResultStepsResponse
} from '@eggplant/types'

interface Props {
  id: string
  isPolling: boolean
  interval?: number
  onSuccess: (data: TestResultStepsResponse) => void
  params?: TestResultStepParams
  children?: (data: TestResultStepsResponse) => ReactElement
}

const PollAiRunStepsRequest = ({
  id,
  isPolling,
  interval = 5000,
  onSuccess,
  params,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs/${id}/steps`

  return (
    <AuthenticatedPolling<TestResultStepsResponse>
      children={children}
      intervalMs={interval}
      isPolling={isPolling}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default PollAiRunStepsRequest
